import { createContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { APP_LINKS } from "../../database/app-link";
import { IHeaderAdminContext } from "./@types";

export const HeaderAdminContext = createContext<IHeaderAdminContext>(
  {} as IHeaderAdminContext
);

export function HeaderAdminContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { pathname } = useLocation();
  const appLinks = useMemo(() => APP_LINKS, []);

  const [title, setTitle] = useState<React.ReactNode>(null);
  const [disableHeader, setDisableHeader] = useState(false);
  const [action, setAction] = useState<React.ReactNode>(null);

  useEffect(() => {
    const link = appLinks.find(({ link }) => link === pathname);
    if (link?.label) {
      setTitle(link.label);
      setAction(null);
    }
  }, [pathname, appLinks]);

  return (
    <HeaderAdminContext.Provider
      value={{
        title,
        setTitle,
        action,
        setAction,
        disableHeader,
        setDisableHeader,
      }}
    >
      {children}
    </HeaderAdminContext.Provider>
  );
}
